import type { FlexVendor, FlexCode, FlexGlCode } from 'API';
import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';

interface FlexVendorDropdownProps {
  selectedGlCode?: FlexGlCode | null;
  selectedProject?: FlexCode | null;
  selectedVendor?: FlexVendor | null;
  onValueChange: (option: FlexVendor | null) => void;
  disabled?: boolean;
  disableHeader?: boolean;
  placeholder?: string | null;
}

const FlexVendorDropdown = ({
  selectedGlCode,
  selectedProject,
  selectedVendor,
  onValueChange,
  disabled,
  disableHeader = false,
}: FlexVendorDropdownProps) => {
  return (
    <CodingEntityDropdown<FlexVendor>
      erpType="flex"
      entityType="vendors"
      selectedItem={selectedVendor}
      selectedGlCode={selectedGlCode}
      selectedProject={selectedProject}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
    />
  );
};

export default FlexVendorDropdown;
